import type { EntityCollection } from "@firecms/core";
import { Button } from "@firecms/ui";
import { useCallback, useState } from "react";
import type { Space } from "../collections/spaces";
import { useAdminTranslation } from "../i18n/useAdminTranslation";
import { ImportLearningPathModal } from "./ImportLearningPathModal";

type ImportLearningPathJsonButtonProps = {
  accountId: string;
  collection: EntityCollection<Space>;
};

export function ImportLearningPathJsonButton({
  accountId,
  collection,
}: ImportLearningPathJsonButtonProps) {
  const [open, setOpen] = useState(false);
  const { t: ta } = useAdminTranslation();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="outlined">
        {ta("learningPathImport.button")}
      </Button>
      <ImportLearningPathModal
        open={open}
        onClose={handleClose}
        accountId={accountId}
        spaceCollection={collection}
      />
    </>
  );
}
